define('modules/accounts/users/index',['require','exports','module','./model','./collection','./detail/view','./list/view'],function(require, exports, module) {
    "use strict";

    var Model = require("./model");
    var Collection = require("./collection");
    var DetailView = require("./detail/view");
    var ListView = require("./list/view");

    module.exports = {
        Model: Model,
        Collection: Collection,
        Views: {
            Detail: DetailView,
            List: ListView
        }
    };

});

